import type Currency from './currency';
import type { languageCodes } from '~~/i18n/enums/languageCodes';
import type { countryCodes } from '~~/i18n';

export type CountryCodeValue = ValueOf<typeof countryCodes>;
export type LanguageIdentification =
  { language: ValueOf<typeof languageCodes>, countryCode : CountryCodeValue };
export type ParcelPerformByLanguage = { language?: ValueOf<typeof languageCodes>, parcelPerformId: string };

export const RECOMMENDATION_TYPE_NAME = {
  SIMILAR_PRODUCTS: 'similarProductsId',
  LAST_SEEN: 'lastSeenId',
  CART_RECOMMENDATION: 'cartRecommendationId',
} as const;
export const RECOMMENDATION_EVENT_NAME = {
  [RECOMMENDATION_TYPE_NAME.SIMILAR_PRODUCTS]: 'Similar Products',
  [RECOMMENDATION_TYPE_NAME.LAST_SEEN]: 'Last Seen',
  [RECOMMENDATION_TYPE_NAME.CART_RECOMMENDATION]: 'Cart Recommendation',
};
export const RECOMMENDATION_DESCRIPTION = {
  [RECOMMENDATION_TYPE_NAME.SIMILAR_PRODUCTS]: 'view similar products section',
  [RECOMMENDATION_TYPE_NAME.LAST_SEEN]: 'view last seen products section',
  [RECOMMENDATION_TYPE_NAME.CART_RECOMMENDATION]: 'view cart recommendations section',
} as const;
export type RecommendationTypeName = ValueOf<typeof RECOMMENDATION_TYPE_NAME>;
export type BloomreachKeyByLanguage = {
  key: string,
  language?: ValueOf<typeof languageCodes>,
};
export type VueI18nNumberFormats = { [key: string]: { currency: Currency } };
export type VueI18nFormattedLocales = Array<{
  code: string,
  label: string,
  file?: string,
  files?: string[],
  country: string,
  language: string
}>;
